<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <header class="content__title pl-0">
            <h1>
                <b-link :to="{name: 'countries.browse'}">&ldquo;{{ country.name }}&rdquo;</b-link>
                / Regions
            </h1>

            <div class="actions">
                <a class="btn btn-success btn--icon" @click.prevent="showCreateDialog"
                   v-b-tooltip.left title="Add new region"><i class="zmdi zmdi-plus"></i></a>
            </div>
        </header>

        <div class="card">
            <div class="bg-primary align-items-center d-flex">
                <h5 class="card-header text-white">All Regions</h5>
                <b-pagination align="right" class="my-auto mr-2 ml-auto"
                              :total-rows="pagination.total"
                              v-model="pagination.page"
                              :per-page="pagination.limit"
                />
            </div>
            <b-table hover stacked="md" :items="tableData" sort-by="name" :fields="table.fields"
                     :per-page="pagination.limit" :current-page="pagination.page"
                     :show-empty="true">
                <template slot="badges" slot-scope="data">
                    <span class="badge badge-danger" v-if="data.item.deleted_at">
                    Disabled
                    </span>
                </template>
                <template slot="actions" slot-scope="row">
                    <b-button @click="showEditDialog(row.item)" variant="secondary btn--icon" v-b-tooltip.hover="'Edit Region'">
                        <i class="zmdi zmdi-edit"></i>
                    </b-button>
                    <b-button :to="{name:'districts.browse', params: {regionId: row.item.id}}"
                              variant="info btn--icon" v-b-tooltip.hover="'View Districts'">
                        <i class="zmdi zmdi-chevron-right"></i>
                    </b-button>
                </template>
            </b-table>
        </div>
        <CreateModal :close="closeCreateDialog" :country="country" v-model="creating" v-if="creating" />
        <EditModal :close="closeEditDialog" v-model="editingRegion" v-if="editingRegion"
                   :region="editingRegion" :country="country" />
    </div>
</template>

<script>
import findCountryQuery from '@views/Regions/Browse/queryFindCountry.graphql';
import listRegionsQuery from '@views/Regions/Browse/queryListRegions.graphql';

import CreateModal from './CreateModal';
import EditModal from './EditModal';

export default {
  name: 'BrowseRegions',
  props: {
    countryId: {
      required: true,
    },
  },
  apollo: {
    country: {
      query: findCountryQuery,
      update: data => data.findCountry,
      variables() {
        return {
          input: {
            id: this.countryId,
          },
        };
      },
    },
    regions: {
      query: listRegionsQuery,
      variables() {
        return {
          input: {
            country_id: this.countryId,
            include_deleted: true,
          },
        };
      },
      manual: true,
      result({ data, loading }) {
        if (!loading) {
          this.regions = data.filterRegions.data;
          this.pagination.total = data.filterRegions.meta.total;
        }
      },
    },
  },
  data() {
    return {
      regions: [],
      country: null,
      editingRegion: null,
      creating: false,
      loading: 0,
      pagination: {
        page: 1,
        limit: this.$tableDefaultPageSize,
        total: 0,
      },
      table: {
        fields: [
          {
            key: 'name',
            label: 'Region',
            sortable: true,
          },
          {
            key: 'badges',
            label: 'Statuses',
          },
          {
            key: 'actions',
            label: '',
            tdClass: 'text-right',
          },
        ],
      },
    };
  },
  computed: {
    tableData() {
      return (this.regions || []).map(item => ({
        ...item,
      }));
    },
  },
  methods: {
    showEditDialog(region) {
      this.editingRegion = region;
    },
    closeEditDialog() {
      this.editingRegion = null;
    },
    showCreateDialog() {
      this.creating = true;
    },
    closeCreateDialog() {
      this.creating = false;
    },
  },
  components: {
    EditModal,
    CreateModal,
  },
};
</script>
